import React from 'react';

function TableRow({team, index}) {

// feelin' lazy, just copied this
	const convertMilliseconds = (ms, p) => {

        var pattern = p || "hh:mm:ss",
			arrayPattern = pattern.split(":"),
			clock = [ ],
			hours = Math.floor ( ms / 3600000 ), // 1 Hour = 36000 Milliseconds
			minuets = Math.floor (( ms % 3600000) / 60000), // 1 Minutes = 60000 Milliseconds
			seconds = Math.floor ((( ms % 360000) % 60000) / 1000) // 1 Second = 1000 Milliseconds
			
			
			
		// build the clock result
		const createClock = (unit) =>{
		
		
		// match the pattern to the corresponding variable
		if (pattern.match(unit)) {
			if (unit.match(/h/)) {
				addUnitToClock(hours, unit);
			}
			if (unit.match(/m/)) {
				addUnitToClock(minuets, unit);
			}
			if (unit.match(/s/)) {
				addUnitToClock(seconds, unit);
			};
			}
		}

		function addUnitToClock(val, unit){
		
			if ( val < 10 && unit.length === 2) {
				val = "0" + val;
			}
		
			clock.push(val); // push the values into the clock array
		
		}


		// loop over the pattern building out the clock result
		for ( var i = 0, j = arrayPattern.length; i < j; i ++ ){
		
			createClock(arrayPattern[i]);
		
		}

		return {
			hours : hours,
			minuets : minuets,
			seconds : seconds,
			clock : clock.join(":")
		};

	}

	return (<div className={(index % 2 === 1 ? 'table-row-odd ' : '') + 'table-row flex w-100 pv3  items-center'}>
			<div className="w-60 tl ph3">
				<h2 className="team-name mb3 mh0 mt0 t-orange">{index + 1}. {team.teamtag.substr(4)}</h2>
				<div className="images flex flex-wrap">
					{(team.members || []).map((member, idx) => 
						<div className={'mh1 mh2-ns mt2 member t-blue tc'} key={idx + 'img'}>
							<img 
								className={'avatars br-100 h3 w3'} src={member.image_url} 
							/>
							<div className="fw6 f7 ">{member.first_name} {member.last_name}</div>
							<div className="f7">{member.distance_m} meters</div>
						</div>
					)}
				</div>	
			</div>
			<div className="w-40">
				<div className="f4">{convertMilliseconds(team.total_time_ms, 'hh:mm:ss').clock}</div>
				<div className="mt2 f7">{team.total_distance_m} meters ({team.togo_distance_m} left)</div>
			</div>
		</div>)
}

export default TableRow;